import React from 'react';
import { Outlet } from 'react-router-dom';
import { ParentMenu } from '../components/ParentMenu';

export const ParentLayout: React.FC = () => {
    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <ParentMenu />
            <main className="flex-1 max-w-6xl w-full mx-auto p-4 md:p-8">
                <Outlet />
            </main>
        </div>
    );
};
